import React, { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import useStyles from "./styles";
import { FormInput } from "../widgets/FormInput";
import { CheckboxInput } from "../widgets/CheckBoxInput";
import { ActionButton } from "../widgets/ActionButton";
import { Button } from "@material-ui/core";
import { SelectInput } from "../widgets/SelectInput";
import { SettingsModal } from "../models/policy.model";
function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `45%`,
    left: `50%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const AddSettingsModal = (props) => {
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const {
    open,
    handleRemove,
    handleSubmit,
    handleCheckbox,
    modalData,
    modalClose,
    isLoading,
    categories,
    selected,
    load,
    emptyFlag,
  } = props;
  const [formData, setFormData] = useState(SettingsModal);
  useEffect(() => {
    if (open) {
      formData.reasonType = "";
      formData.description = "";
      setFormData({
        ...formData,
        description: "",
        reasonType: "",
      });
    }
  }, [open]);
  useEffect(() => {
    if (emptyFlag) {
      formData.reasonType = "";
      formData.description = "";
      setFormData({
        ...formData,
        description: "",
        reasonType: "",
      });
    }
  }, [emptyFlag]);
  // Handle Change Form Input Value
  const handleChange = (evt) => {
    evt.persist();
    const { name, value } = evt.target;
    setFormData({
      ...formData,
      [name]: value.toUpperCase().trim(),
    });
  };
  const body = (
    <div style={modalStyle} className={classes.paper800}>
      <div className={classes.modalBody}>
        <h4 className={classes.modalTitle} id="simple-modal-title">
          {modalData.static.title}
        </h4>
        <div className={classes.modalContent}>
          <div className="row center-c mb-2">
            <div className="col-md-3">
              <div className="settings-add-text">
                {modalData.static.addText}
              </div>{" "}
            </div>
            <div
              className={`${
                modalData.static.maintainceType === "reasonType" ||
                modalData.static.maintainceType === "suspReason" ||
                modalData.static.maintainceType === "threeOptions" ||
                modalData.static.maintainceType === "note"
                  ? "d-none"
                  : "col-md-2"
              }`}
            >
              <SelectInput
                id="reasonType"
                name="reasonType"
                onChange={handleChange}
                value={formData.reasonType}
                fullWidth={true}
                options1={categories}
              />
            </div>
            <div className="col-md-5">
              <FormInput
                id="description"
                type="text"
                size="small"
                name="description"
                value={formData.description}
                fullWidth={true}
                onChange={handleChange}
                multiline={true}
                placeholder="This is multiline text"
              />
            </div>

            <div className="col-md-2">
              {modalData.static.maintainceType === "imageCategory" ? (
                <ActionButton
                  variant="contained"
                  className="cancel m-0"
                  type="button"
                  onClick={() => handleSubmit(formData)}
                  buttonLable="Add"
                  fullWidth={true}
                  color="primary"
                  disabled={
                    isLoading || !formData.description || !formData.reasonType
                  }
                  isLoading={!isLoading}
                />
              ) : (
                <ActionButton
                  variant="contained"
                  className="cancel m-0"
                  type="button"
                  onClick={() => handleSubmit(formData)}
                  buttonLable="Add"
                  fullWidth={true}
                  color="primary"
                  disabled={isLoading || !formData.description}
                  isLoading={!isLoading}
                />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 p-0 table-settings">
              <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover table-sm">
                  <thead>
                    <tr className="settings-tr">
                      {modalData.static.columns
                        ? modalData.static.columns.map((item, index) => {
                            return (
                              <>
                                {" "}
                                {item.key === "checkboxAll" ? (
                                  <th>
                                    <CheckboxInput
                                      id="selectAll"
                                      size="small"
                                      label=""
                                      name="selectAll"
                                      onChange={(evt) => handleCheckbox(evt)}
                                      color="skyBox"
                                      className="skyLable"
                                      margin="m-0"
                                    />
                                  </th>
                                ) : (
                                  <th>{item.label}</th>
                                )}
                              </>
                            );
                          })
                        : null}
                    </tr>
                  </thead>
                  <tbody>
                    {modalData.dynamic
                      ? modalData.dynamic.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {" "}
                                <CheckboxInput
                                  id="selectOne"
                                  size="small"
                                  label=""
                                  name="selectOne"
                                  onChange={(evt) => handleCheckbox(evt, item)}
                                  color="defaultBox"
                                  className="skyLable"
                                  margin="m-0"
                                  checked={
                                    item.isChecked ? item.isChecked : null
                                  }
                                />
                              </td>
                              <td>
                                {modalData.static.maintainceType ===
                                "imageCategory"
                                  ? item.catType
                                  : item.description}
                              </td>
                              <td
                                className={
                                  modalData.static.maintainceType ===
                                    "imageCategory" ||
                                  modalData.static.maintainceType === "note"
                                    ? ""
                                    : "d-none"
                                }
                              >
                                {modalData.static.maintainceType ===
                                "imageCategory"
                                  ? item.description
                                  : item.user}
                              </td>
                            </tr>
                          );
                        })
                      : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.modalFooter}>
          <ActionButton
            variant="outlined"
            className="cancel"
            type="button"
            onClick={modalClose}
            buttonLable="Close"
            isLoading="none"
          />
          <Button
            variant="contained"
            color="primary"
            type="button"
            onClick={handleRemove}
            disabled={load || selected.length <= 0}
          >
            {!load ? modalData.static.removeText : "Removing..."}
          </Button>
          {/* <ActionButton
                        variant="outlined"
                        color="primary"
                        className="cancel m-0"
                        type="button"
                        onClick={handleRemove}
                        buttonLable={modalData.static.removeText}
                        isLoading="none"
                        disabled={selected.length <= 0}
                    /> */}
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        open={open}
        onClose={handleRemove}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        disableBackdropClick={true}
      >
        {body}
      </Modal>
    </div>
  );
};
export default AddSettingsModal;
